import { z } from 'zod';

// 공지사항 배너 스키마
export const NoticeBannerSchema = z
  .object({
    id: z.number().describe('ID'),
    label: z.string().describe('라벨'),
    title: z.string().describe('제목'),
    link: z.string().describe('링크'),
    labelColor: z.string().nullish().describe('라벨 색상'),
    backgroundColor: z.string().nullish().describe('배경 색상'),
    textColor: z.string().nullish().describe('텍스트 색상'),
  })
  .describe('공지사항 배너 ');

// 수익 상세 정보 스키마
export const EarningsInfoSchema = z
  .object({
    infos: z
      .array(
        z.object({
          title: z.string().describe('제목'),
          content: z
            .array(
              z.object({
                text: z.string().describe('텍스트'),
                subText: z.string().nullish().describe('서브 텍스트'),
              }),
            )
            .describe('내용 목록'),
        }),
      )
      .describe('수익 정보 목록'),
  })
  .describe('수익 정보 ');

// 판매 랭킹 상품 스키마
export const SalesRankingResponseSchema = z
  .object({
    imageUrl: z.string().describe('이미지 URL'),
    brandName: z.string().describe('브랜드명'),
    goodsNo: z.number().describe('상품번호'),
    goodsName: z.string().describe('상품명'),
    price: z.number().describe('가격'),
    totalQuantity: z.number().describe('해당 기간 판매 개수'),
    totalCommission: z.number().describe('해당 기간 수수료 합산 금액'),
    linkUrl: z.string().describe('링크 URL'),
    isLiked: z.boolean().describe('좋아요 여부'),
    salesRate: z.number().int().describe('할인율 (%)'),
  })
  .describe('판매 상품 랭킹 응답');

// 마이페이지  메인 응답 스키마
export const MyPageResponseSchema = z
  .object({
    noticeBanners: z.array(NoticeBannerSchema).describe('공지사항 배너 목록'),
    expectedEarnings: z.number().describe('이번 달 예상 수익'),
    earningsInfo: EarningsInfoSchema.describe('수익 정보'),
    salesRankingGoods: z.array(SalesRankingResponseSchema).describe('누적 판매 상품 목록'),

    // 29CM 전용 필드
    campaignLinks: z
      .array(
        z.object({
          title: z.string().describe('링크 제목'),
          url: z.string().describe('링크 URL'),
        }),
      )
      .nullish()
      .describe('캠페인 & 할인 상품 링크 목록 (29CM 전용)'),

    showAccountInfo: z.boolean().optional().describe('계좌 정보 입력 가능 여부 (무신사·29CM 공통)'),

    accountInfo: z
      .object({
        bankName: z.string().describe('은행명'),
        bankAccountNumber: z.string().describe('계좌번호 (마스킹 처리)'),
      })
      .nullish()
      .describe('계좌 정보 (29CM 전용)'),

    // Musinsa 전용 필드
    waitingCampaigns: z.number().int().nullish().describe('대기중인 캠페인 제안 수 (Musinsa 전용)'),
    approvedCampaigns: z
      .number()
      .int()
      .nullish()
      .describe('진행중인 승인된 캠페인 수 (Musinsa 전용)'),
    waitingReverseProposals: z
      .number()
      .int()
      .nullish()
      .describe('대기중인 역제안 수 (Musinsa 전용)'),

    eventCollectionBanner: z
      .object({
        title: z.string().describe('배너 제목'),
        subTitle: z.string().describe('서브 타이틀'),
        backgroundColor: z.string().nullish().describe('배경 색상'),
        textColor: z.string().nullish().describe('텍스트 색상'),
        images: z.array(z.string()).describe('배너 이미지 URL 목록'),
      })
      .nullish()
      .describe('이벤트 컬렉션 배너 (Musinsa 전용)'),

    appliedCampaignCount: z
      .number()
      .int()
      .describe('내가 신청한 캠페인 수 (쿠폰 역제안 + 시딩 모집형)'),
    receivedProposalCount: z
      .number()
      .int()
      .describe('제안 받은 캠페인 수 (쿠폰 제안 + 시딩 제안형)'),
    recruitingCampaignCount: z.number().int().describe('모집중 캠페인 참여하기 수 (시딩 모집형)'),
  })
  .describe('마이페이지  응답 (멀티플랫폼)');

export type GetMyPageServiceResponse = z.infer<typeof MyPageResponseSchema>;
